<div *ngIf="showCaptcha" class="captcha-container">
  <p class="message mb-2">{{ message }}</p>

  <div
    class="captcha-box"
    #captchaBox
    (click)="checkClick($event)"
    [class.disabled]="isDisabled"
  >
    <img
      [src]="'../../../assets/images/login-page-bg.jpg'"
      class="captcha-image"
    />

    <div
      class="click-box"
      [class.success]="success"
      [style.top.px]="boxY"
      [style.left.px]="boxX"
    >
      <span *ngIf="success" class="checkmark">✅</span>
    </div>
  </div>

  <button *ngIf="!success" (click)="generateNewCaptcha()">Refresh</button>
</div>
